var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DeviceRotate",
    clipPath: "url(#clip0_501_27189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.75C6.55228 8.75 7 9.19772 7 9.75V18.75C7 18.8826 7.05268 19.0098 7.14645 19.1036C7.24022 19.1973 7.36739 19.25 7.5 19.25H18.75C19.3023 19.25 19.75 19.6977 19.75 20.25C19.75 20.8023 19.3023 21.25 18.75 21.25H7.5C6.83696 21.25 6.20107 20.9866 5.73223 20.5178C5.26339 20.0489 5 19.413 5 18.75V9.75C5 9.19772 5.44772 8.75 6 8.75Z",
    fill: "#192851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 3.75C4.25 3.19772 4.69772 2.75 5.25 2.75H16.5C17.163 2.75 17.7989 3.01339 18.2678 3.48223C18.7366 3.95107 19 4.58696 19 5.25V14.25C19 14.8023 18.5523 15.25 18 15.25C17.4477 15.25 17 14.8023 17 14.25V5.25C17 5.11739 16.9473 4.99022 16.8536 4.89645C16.7598 4.80268 16.6326 4.75 16.5 4.75H5.25C4.69772 4.75 4.25 4.30228 4.25 3.75Z",
    fill: "#192851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7929 17.2929C16.1834 16.9024 16.8166 16.9024 17.2071 17.2929L19.4571 19.5429C19.8476 19.9334 19.8476 20.5666 19.4571 20.9571L17.2071 23.2071C16.8166 23.5976 16.1834 23.5976 15.7929 23.2071C15.4024 22.8166 15.4024 22.1834 15.7929 21.7929L17.3358 20.25L15.7929 18.7071C15.4024 18.3166 15.4024 17.6834 15.7929 17.2929Z",
    fill: "#192851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20711 0.792893C8.59763 1.18342 8.59763 1.81658 8.20711 2.20711L6.66421 3.75L8.20711 5.29289C8.59763 5.68342 8.59763 6.31658 8.20711 6.70711C7.81658 7.09763 7.18342 7.09763 6.79289 6.70711L4.54289 4.45711C4.15237 4.06658 4.15237 3.43342 4.54289 3.04289L6.79289 0.792893C7.18342 0.402369 7.81658 0.402369 8.20711 0.792893Z",
    fill: "#192851"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_27189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#192851"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateBlack);
export default __webpack_public_path__ + "static/media/RotateBlack.fb0b516475999008ced80c47c1720207.svg";
export { ForwardRef as ReactComponent };